import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IReturnPackagingSettings } from '@cakeiteasy/web-utils';

import { RETURN_METHODS } from '../../models/return-packaging.constants';

interface IReturnMethodOption {
  method: RETURN_METHODS;
  title: string;
  description: string;
}

/**Rendered only when the seller offers both return methods. With a single method the step skips
 * straight to that method's schedule, so there is nothing to choose.*/
@Component({
  standalone: true,
  selector: 'return-method-choice',
  imports: [TranslateModule],
  templateUrl: './return-method-choice.component.html',
  styleUrls: ['./return-method-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnMethodChoiceComponent {
  readonly settings = input.required<IReturnPackagingSettings>();
  readonly selected = input<RETURN_METHODS>(null);

  readonly methodChange = output<RETURN_METHODS>();

  readonly options = computed<IReturnMethodOption[]>(() => {
    const settings = this.settings();
    const options: IReturnMethodOption[] = [];

    if (settings.allowReturnThemselves) {
      options.push({
        method: RETURN_METHODS.SELF,
        title: settings.returnThemselvesTitle,
        description: settings.returnThemselvesDescription,
      });
    }

    if (settings.allowReturnCourier) {
      options.push({
        method: RETURN_METHODS.COURIER,
        title: settings.returnCourierTitle,
        description: settings.returnCourierDescription,
      });
    }

    return options;
  });
}
